import eyercloud from '@/config/eyercloud'

class StripeService {

  async createCheckoutSession(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/create-checkout`, params)
    return response.data
  }

  async updateSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/update-subscription`, params)
    return response.data
  }

  async cancelSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/cancel-subscription`, params)
    return response.data
  }

  async list() {
    let response = await eyercloud.get(`/api/v2/eyercloud/stripe/list-products`)
    return response.data
  }

  async getPrice(params) {
    console.log('params');
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/price`, params)
    return response.data
  }

  async getSubscribers(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/subscribers`, params)
    return response.data
  }

  async getClinicSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/clinic-subscription`, params)
    return response.data
  }


}
const stripeService = new StripeService();
export default stripeService;
